import { render, staticRenderFns } from "./polaris-editor.vue?vue&type=template&id=2a5d6816&"
import script from "./polaris-editor.vue?vue&type=script&lang=js&"
export * from "./polaris-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports